/* eslint-disable @typescript-eslint/consistent-type-assertions */
import AlertMessage from 'Components/AlertMessage'
import EmailIcon from '@mui/icons-material/Email'
import { useState } from 'react'
import { type duplicateResolution, type ChildDuplicate, originalSelector, useCreateDuplicateMutation, dupeSelector } from 'slices/duplicateChildSlice'
import { Button, CircularProgress, Box } from '@mui/material'
import { toast } from 'react-toastify'
import { useAppSelector } from 'hooks/reduxHooks'
import { TextAreaWithLabel } from 'Components/TextArea'
import { useParams } from 'react-router'

export function DuplicateRequestReview (props: { userType: 'caregiver' | 'provider', userId: number | null, isIntakeForm: boolean }): JSX.Element {
  const [created, setCreated] = useState({ sent: false, success: false })
  const dupeData = useAppSelector(dupeSelector)
  const existingRecord = useAppSelector(originalSelector)
  const [createDupe] = useCreateDuplicateMutation()
  const [notes, setNotes] = useState('')
  const caregiverWizardKey = 'caregiverWizardKey'
  const { isdId } = useParams()

  const onSubmitForReview = async (): Promise<void> => {
    if (!created.sent) {
      if (props.userType === 'caregiver' && (notes == null || notes === '')) {
        toast.error('Please enter some details about the services you are looking for')
        return
      }
      const wizardKey = props.isIntakeForm ? window.localStorage.getItem(caregiverWizardKey) : null

      setCreated({ sent: true, success: false })
      const submitValue = {
        ...dupeData,
        matchedValues: existingRecord[0]?.matchedValues,
        probability: existingRecord[0]?.probability
      } as ChildDuplicate
      const resolution: duplicateResolution = {
        reasoning: '',
        duplicateId: submitValue?.id ?? null,
        duplicate: submitValue,
        caregiverID: (props.userType === 'caregiver' ? props.userId : null) ?? 0,
        providerID: props.userType === 'provider' ? props.userId : null,
        matchedChildID: existingRecord[0]?.childId ?? 0,
        matchedChildNickName: submitValue?.nickName ?? null,
        source: submitValue?.source,
        childID: submitValue?.childId ?? null,
        sessionKey: props.userType === 'caregiver' ? wizardKey : null,
        notes
      }
      if (props.isIntakeForm) {
        resolution.isdId = isdId
      }
      const val = await createDupe(resolution)
      if (val != null && Number.isInteger(val.data)) {
        setCreated({ sent: true, success: true })
      } else {
        toast.error('Unable to submit duplicate for review. Please reach out to the contact listed.')
        setCreated({ sent: false, success: false })
      }
    }
  }
  return <>
    {props.userType === 'caregiver' && dupeData != null && (
      <TextAreaWithLabel disabled={created.sent} label='Please let us know what services you are interested in.'
        value={notes} onChange={(e) => { setNotes(e.target.value.toString()) }} name={''}
      />
    )}
    {!created.success && dupeData != null && (
      <Button startIcon={created.sent ? <CircularProgress sx={{ width: '5px', height: '5px' }} color='info' /> : undefined}
        disabled={created.sent} onClick={onSubmitForReview} variant='contained'
      >Submit duplicate for review</Button>
    )}
    {created.success && (<Box sx={{ maxWidth: '200px', alignContent: 'center', pl: 2 }}>
      <AlertMessage type={'success'} icon={<EmailIcon/>} message={'Duplicate request submitted.'} />
    </Box>
    )}

  </>
}
